import {getQuanmaiApi,postQuanmaiApi,postQuanmaiApiFlie,getCommonApi} from './proxy'

export default class {
//获取首页的红点显示
GetRedPoint(userId) {
    return getQuanmaiApi('/Index/getIndexRed', { UserId: userId });
}
 //获取新闻列表
 GetNewsList(data) {
    return getQuanmaiApi('/Articles/getNewLst', data);
}
//获取用户是否开启对某用户的授权
GetAccept(data) {
    return getQuanmaiApi('/Checks/getAuth', data);
}
//用户开启/关闭授权
SetAccept(data) {
    return postQuanmaiApi('/Checks/setAuth', data);
}

//意见反馈
FeedBack(data) {
    return postQuanmaiApi("/Index/feedback", data);
}
//用户充值（充值卡充值）
CardPay(data) {
    return postQuanmaiApi('/Orders/bindCode', data)
}
 //下单接口
 OrderSubmit(data) {
    return postQuanmaiApi('/Orders/submit', data);
}
 //获取消费方式列表
 GetBill() {
    return getQuanmaiApi('/Orders/getBill', {});
}
 //判断订单有没有完成
 CheckOrder(data) {
    return postQuanmaiApi('/Orders/checkOrderStatus', data);
}
 //支付宝支付接口
 aliPayWeb(data) {
    return getQuanmaiApi('/Orders/alipayWeb', data);
}
//微信支付
WeChatPay(data) {
    return getQuanmaiApi('/Orders/webchatWeb', data)
}
//微信h5支付
WeChatPayH5(data) {
    return getQuanmaiApi('/Orders/webchatH5', data);
}
//上传图片
UploadImg(data) {
    return postQuanmaiApiFlie('/Index/uploadFile', data);
}
 // /获取公司接口
 GetCompany(data) {
    return getQuanmaiApi('/Index/getCompany',data);
}
//获取子公司接口
GetChildCompany(data) {
    return getQuanmaiApi("/Index/getChildCompany", data);
}
//获取部门接口
GetDepart(data) {
    return getQuanmaiApi("/Index/getDepart", data);
}
//获取省份接口
GetProvince() {
    return getCommonApi("/area/province", {});
}
//获取城市接口
GetCity(data) {
    return getCommonApi("/area/city", data);
}
//获取地区接口
GetArea(data) {
    return getCommonApi("/area/district", data);
}
//获取协议地址
GetAgreementUrl() {
    return getQuanmaiApi('/Index/getConf', {});
}
  //获取用户是否开启对某用户的授权
  GetAccept(data) {
    return getQuanmaiApi('/Checks/getAuth', data);
}
  //极光签名接口
  JimSecret() {
    return getQuanmaiApi('/Index/jiguang', {});
}
 //同步极光用户接口
 RegistJg(data) {
    return postQuanmaiApi('/Users/registJg', data)
}
//测试环境支付回调处理接口
DealOrder(data) {
    return getQuanmaiApi('/Orders/dealOrder', data);
}
}


// WEBPACK FOOTER //
// ./src/service/commenService.js